import React, { useMemo } from 'react';
import { IBaseProps } from './types'
import BookedByForEditBooking from 'design-v2/common/BookedBy/LegacyDiary/BookedByForEditBooking'
import Box from '@material-ui/core/Box';
import AdminService from 'external-services/diary-admin-service/admin.service';
import BookedByForNewBooking from 'design-v2/common/BookedBy/LegacyDiary/BookedByForNewBooking';

export default function ExistingCustomerSearch(props: IBaseProps) {
  const country = useMemo(() => AdminService.getVenue().country, []);
  const gridLayout = useMemo(() => (props.mode === 'new' ? 'wide' : 'narrow'), [props.mode]);
  return (
    <Box display="flex" width="100%" justifyContent="space-between">
      {props.mode === 'new' ?
        <BookedByForNewBooking
          {...props}
          handleChange={props.setCustomer}
          country={country}
        />
        : <BookedByForEditBooking
          {...props}
          handleChange={props.setCustomer}
          country={country}
          layout={gridLayout}
        />}
    </Box>
  )
}

